export default __webpack_public_path__ + "static/media/uncl.606ada4d.png";